import config from "../../config";
import {
    ADD_PAYMENT_METHOD,
    GET_PAYMENT_METHODS,
    REMOVE_PAYMENT_METHOD,
    START_LOADER,
    STOP_LOADER,
} from "./types";

export const GetPaymentMethodsAction = () => async (dispatch, getState) => {
    try {
        const headers = config.bearerHeaders(getState().auth.token);
        const res = await config.getApi(
            config.services.getPaymentMethods(),
            headers
        );
        if (res) {
            dispatch({ type: GET_PAYMENT_METHODS, payload: res.response.data });
        }
    } catch (e) {
        console.log(e);
    }
};

export const AddPaymentMethodAction =
    (stripeToken) => async (dispatch, getState) => {
        try {
            dispatch({ type: START_LOADER });
            const headers = config.bearerHeaders(getState().auth.token);
            const data = JSON.stringify({
                source: stripeToken,
            });
            const res = await config.postApi(
                config.services.addCard(),
                headers,
                data
            );
            console.log("Add Payment Method",res.response.data);
            dispatch({ type: STOP_LOADER });
            if (res) {
                dispatch({
                    type: ADD_PAYMENT_METHOD,
                    payload: res.response.data,
                });
            }
        } catch (e) {
            dispatch({ type: STOP_LOADER });
            console.log(e);
        }
    };

export const RemovePaymentMethodAction = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: START_LOADER });
        const headers = config.bearerHeaders(getState().auth.token);
        const data = JSON.stringify({
            id,
        });
        const res = await config.postApi(
            config.services.removeCard(),
            headers,
            data
        );
        dispatch({ type: STOP_LOADER });
        if (res) {
            dispatch({ type: REMOVE_PAYMENT_METHOD, payload: id });
        }
    } catch (e) {
        dispatch({ type: STOP_LOADER });
        console.log(e);
    }
};

export const UpdateDefaultCard = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: START_LOADER });
        const headers = config.bearerHeaders(getState().auth.token);
        const data = JSON.stringify({ id });
        const res = await config.postApi(
            config.services.updateDefaultCard(),
            headers,
            data
        );
        dispatch({ type: STOP_LOADER });
        if (res) {
            dispatch(GetPaymentMethodsAction());
        }
    } catch (e) {
        dispatch({ type: STOP_LOADER });
        console.log(e);
    }
};
